export const X_TWEET_MAX_LENGTH = 280;
function charWeight(ch) {
    const cp = ch.codePointAt(0) ?? 0;
    if (cp <= 0x10ff)
        return 1;
    if (cp >= 0x2000 && cp <= 0x200d)
        return 1;
    if (cp >= 0x2010 && cp <= 0x201f)
        return 1;
    if (cp >= 0x2032 && cp <= 0x2037)
        return 1;
    return 2;
}
export function getXTweetWeightedLength(text) {
    let total = 0;
    for (const ch of text)
        total += charWeight(ch);
    return total;
}
export function truncateXTweetByWeightedLength(text, max) {
    let weight = 0;
    let out = '';
    for (const ch of text) {
        const w = charWeight(ch);
        if (weight + w > max)
            break;
        out += ch;
        weight += w;
    }
    return out;
}
//# sourceMappingURL=x.const.js.map